import { InventoryPeriodSortOption } from '@rematter/frontend-lib-api-client';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type InventoryPeriodRecord = {
  id: string;
  name: string;
  periodType: string;
  startDate: string;
  endDate: string;
  status: string;
  facilityId: string;
  facilityName: string;
  closedAt: string | null;
  closedBy: string | null;
  lockedAt: string | null;
  lockedBy: string | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
};

export const inventoryPeriodsQueryAtom = createQueryAtomFactory(
  'inventory.inventoryPeriods',
  (params: {
    facilityIds?: string[];
    status?: string;
    limit?: number;
    offset?: number;
    sorting?: InventoryPeriodSortOption[];
  }) => ({
    inventoryPeriods: {
      __args: {
        filter: {
          facilityIds: params.facilityIds,
          status: params.status,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 25,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        periodType: true,
        startDate: true,
        endDate: true,
        status: true,
        facilityId: true,
        closedAt: true,
        closedBy: true,
        lockedAt: true,
        lockedBy: true,
        notes: true,
        facility: {
          id: true,
          facilityName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (
      data,
    ): {
      periods: InventoryPeriodRecord[];
      totalCount: number;
    } => {
      if (!data?.inventoryPeriods?.entries) {
        return {
          periods: [],
          totalCount: 0,
        };
      }

      const periods = data.inventoryPeriods.entries.map(
        (period): InventoryPeriodRecord => ({
          id: period.id,
          name: period.name,
          periodType: period.periodType,
          startDate: period.startDate,
          endDate: period.endDate,
          status: period.status,
          facilityId: period.facilityId,
          facilityName: period.facility?.facilityName || '',
          closedAt: period.closedAt || null,
          closedBy: period.closedBy || null,
          lockedAt: period.lockedAt || null,
          lockedBy: period.lockedBy || null,
          notes: period.notes || null,
          createdAt: period.timestamps?.createdAt || '',
          updatedAt: period.timestamps?.updatedAt || '',
        }),
      );

      return {
        periods,
        totalCount: data.inventoryPeriods.page?.total || 0,
      };
    },
  },
);
